/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProgramModuleDocument
 */
export interface ProgramModuleDocument {
    /**
     * 
     * @type {string}
     * @memberof ProgramModuleDocument
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramModuleDocument
     */
    url: string;
}

/**
 * Check if a given object implements the ProgramModuleDocument interface.
 */
export function instanceOfProgramModuleDocument(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "url" in value;

    return isInstance;
}

export function ProgramModuleDocumentFromJSON(json: any): ProgramModuleDocument {
    return ProgramModuleDocumentFromJSONTyped(json, false);
}

export function ProgramModuleDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramModuleDocument {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'url': json['url'],
    };
}

export function ProgramModuleDocumentToJSON(value?: ProgramModuleDocument | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'url': value.url,
    };
}

